import { useEffect } from 'react';
import { GetStaticPaths, GetStaticProps } from 'next';
import { useSessionState } from '../logic/sessionStore';
import { Study } from '../components/Study/Study';

export default function Home({ messages }: { messages: { [lang: string]: { [id: string]: string } } }) {
  const isBrowser = typeof window !== 'undefined';

  useEffect(() => {
    if (isBrowser) useSessionState.setState({ translations: messages });
  }, [isBrowser, messages]);

  return <Study />;
}

export const getStaticProps: GetStaticProps = async context => {
  const { config } = require('config');

  const body = new URLSearchParams();
  body.append('api_token', config.poeditor.token);
  body.append('id', config.poeditor.id);

  const {
    result: { languages },
  } = await fetch('https://api.poeditor.com/v2/languages/list', {
    method: 'POST',
    body,
  }).then(response => response.json());

  const messages: { [lang: string]: { [id: string]: string } } = {};

  for (const language of languages) {
    const langBody = new URLSearchParams();
    langBody.append('api_token', config.poeditor.token);
    langBody.append('id', config.poeditor.id);
    langBody.append('language', language.code);

    const {
      result: { terms },
    } = await fetch('https://api.poeditor.com/v2/terms/list', {
      method: 'POST',
      body: langBody,
    }).then(response => response.json());

    messages[language.code] = terms.reduce(
      (data: { [id: string]: string }, { term: id, translation }: { term: string; translation: { content: string } }) => ({
        ...data,
        [id]: translation.content,
      }),
      {}
    );
  }

  return {
    props: {
      messages,
    },
    revalidate: 1,
  };
};

export const getStaticPaths: GetStaticPaths = async () => {
  return { paths: [], fallback: true };
};
